import { requisitar } from "./http";

/**
 * O cadastro de fornecedores — **de quem qualifica**.
 *
 * <p>Fica fora de `producao` de propósito. Qualificar fornecedor é ato de
 * Assuntos Regulatórios; a Produção apenas seleciona entre os já qualificados,
 * pela rota do próprio setor.
 */

export type SituacaoDaQualificacao =
  | "EM_QUALIFICACAO"
  | "QUALIFICADO"
  | "REPROVADO"
  | "SUSPENSO";

export interface FornecedorCadastrado {
  id: string;
  /** De quem é esta qualificação. Ela é **por empresa** — invariante 5. */
  empresaId: string;
  /**
   * O apelido da empresa dona desta qualificação, resolvido no **servidor**.
   *
   * `null` é o estado nomeado de "sem dono", desenhado como defeito.
   */
  empresa: string | null;
  nome: string;
  cnpj: string | null;
  situacao: SituacaoDaQualificacao;
  qualificadoEm: string | null;
  motivo: string | null;
  /** Resolvido no servidor: quem consome não reimplementa a regra. */
  podeFornecer: boolean;
}

export const fornecedores = {
  /**
   * Todos, em qualquer situação — a visão de quem avalia, de **uma ou mais**
   * empresas.
   *
   * <p>`?empresa=A&empresa=B&empresa=C` é o consolidado das três: a
   * distribuidora também compra, e por isso ela aparece aqui e não no seletor
   * de matérias-primas.
   *
   * <p>Uma requisição, não N — mesmas razões de `producao.lotes`. E uma a mais,
   * desta tela: a qualificação é **por empresa**, então o mesmo fornecedor
   * aparece uma vez por empresa em que foi cadastrado, possivelmente em
   * situações diferentes. É o selo de empresa de cada linha que torna isso
   * legível em vez de parecer duplicidade.
   */
  listar: (empresas: readonly string[]) =>
    empresas.length === 0
      ? Promise.resolve<FornecedorCadastrado[]>([])
      : requisitar<FornecedorCadastrado[]>(
          `/fornecedores?${empresas.map((e) => `empresa=${e}`).join("&")}`,
        ),

  /** Cadastra. Nasce EM_QUALIFICACAO e não serve para receber material. */
  cadastrar: (empresa: string, nome: string, cnpj: string | null) =>
    requisitar<{ id: string }>("/fornecedores", {
      metodo: "POST",
      corpo: { empresa, nome, cnpj },
    }),

  qualificar: (id: string) =>
    requisitar<void>(`/fornecedores/${id}/qualificar`, { metodo: "POST", corpo: {} }),

  /** O motivo é obrigatório no servidor: é o que uma inspeção pergunta. */
  reprovar: (id: string, motivo: string) =>
    requisitar<void>(`/fornecedores/${id}/reprovar`, { metodo: "POST", corpo: { motivo } }),

  suspender: (id: string, motivo: string) =>
    requisitar<void>(`/fornecedores/${id}/suspender`, { metodo: "POST", corpo: { motivo } }),
};
